module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-flex-clounm m-four-detail"
  }, [_c('div', {
    staticClass: "m-img-succ"
  }, [_c('img', {
    staticStyle: {
      "width": "84px"
    },
    attrs: {
      "src": require("../../assets/images/wanc@2x.png")
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "m-form-title"
  }, [_vm._v("预定完成")]), _vm._v(" "), _c('p', {
    staticClass: "finish-text"
  }, [_vm._v("微信扫描下方二维码,随时查看服务进度")]), _vm._v(" "), _c('div', {
    staticClass: "m-flex-row m-img-tip"
  }, [_c('div', {
    staticClass: "m-ewm"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/m-erm.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-phone-show",
    staticStyle: {
      "margin-left": "-10px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "207px"
    },
    attrs: {
      "src": require("../../assets/images/m-show-phone-2x.png")
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1bcb130","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/agent/pay-finish.vue
// module id = 239
// module chunks = 1 5